/**
 * This file is only used in next-sitemap.config.js due to compiler runtime
 */
const SHIPPING_COUNTRY_CODES = {
    Austria: "at",
    Belgium: "be",
    Bulgaria: "bg",
    Croatia: "hr",
    Cyprus: "cy",
    CzechRepublic: "cz",
    Denmark: "dk",
    Estonia: "ee",
    Finland: "fi",
    France: "fr",
    Germany: "de",
    Greece: "gr",
    Hungary: "hu",
    Ireland: "ie",
    Italy: "it",
    Latvia: "lv",
    Lithuania: "lt",
    Luxembourg: "lu",
    Malta: "mt",
    Netherlands: "nl",
    Norway: "no",
    Poland: "pl",
    Portugal: "pt",
    Romania: "ro",
    Slovakia: "sk",
    Slovenia: "si",
    Spain: "es",
    Sweden: "se",
    Switzerland: "ch",
    UnitedKingdom: "gb",
    Canada: "ca",
    USA: "us",
    Australia: "au",
    NewZealand: "nz",
    Japan: "jp"
}

const SHIPPING_COUNTRIES = {
    Austria: "austria",
    Australia: "australia",
    Belgium: "belgium",
    Bulgaria: "bulgaria",
    Canada: "canada",
    Croatia: "croatia",
    Cyprus: "cyprus",
    CzechRepublic: "czech republic",
    Denmark: "denmark",
    Estonia: "estonia",
    UnitedKingdom: "united kingdom",
    Finland: "finland",
    France: "france",
    Germany: "germany",
    Greece: "greece",
    Hungary: "hungary",
    Italy: "italy",
    Ireland: "ireland",
    Japan: "japan",
    Latvia: "latvia",
    Lithuania: "lithuania",
    Luxembourg: "luxembourg",
    Malta: "malta",
    Netherlands: "netherlands",
    NewZealand: "new zealand",
    Norway: "norway",
    Poland: "poland",
    Portugal: "portugal",
    Romania: "romania",
    Slovakia: "slovakia",
    Slovenia: "slovenia",
    Spain: "spain",
    Sweden: "sweden",
    Switzerland: "switzerland",
    USA: "usa"
}

const getCountryKeyFromCountryValue = countryValue => {
    const entries = Object.entries(SHIPPING_COUNTRIES)
    const foundEntry = entries.find(([, value]) => value === countryValue)
    return foundEntry ? foundEntry[0] : undefined
}

const getCountryCodeByCountryNameCurried =
    (shippingCountryCodes, shippingCountries, getCountryKey) => countryName => {
        const isCountryValue = Object.values(shippingCountries).includes(countryName)
        const countryKey = isCountryValue ? getCountryKey(countryName) : countryName
        return countryKey ? shippingCountryCodes[countryKey] : undefined
    }

const getCountryCodeByCountryName = getCountryCodeByCountryNameCurried(
    SHIPPING_COUNTRY_CODES,
    SHIPPING_COUNTRIES,
    getCountryKeyFromCountryValue
)

const CENTRA_LANGUAGE_CODE = {
    De: "de",
    En: "en",
    Fr: "fr",
    Ja: "ja"
}

const euLocales = [
    `${CENTRA_LANGUAGE_CODE.En}`,
    `${CENTRA_LANGUAGE_CODE.De}`,
    `${CENTRA_LANGUAGE_CODE.Fr}`,
    `${CENTRA_LANGUAGE_CODE.En}-${getCountryCodeByCountryName(SHIPPING_COUNTRIES.CzechRepublic)}`,
    `${CENTRA_LANGUAGE_CODE.En}-${getCountryCodeByCountryName(SHIPPING_COUNTRIES.Denmark)}`,
    `${CENTRA_LANGUAGE_CODE.En}-${getCountryCodeByCountryName(SHIPPING_COUNTRIES.Norway)}`,
    `${CENTRA_LANGUAGE_CODE.En}-${getCountryCodeByCountryName(SHIPPING_COUNTRIES.Poland)}`,
    `${CENTRA_LANGUAGE_CODE.En}-${getCountryCodeByCountryName(SHIPPING_COUNTRIES.Sweden)}`,
    `${CENTRA_LANGUAGE_CODE.En}-${getCountryCodeByCountryName(SHIPPING_COUNTRIES.Switzerland)}`,
    `${CENTRA_LANGUAGE_CODE.De}-${getCountryCodeByCountryName(SHIPPING_COUNTRIES.Switzerland)}`,
    `${CENTRA_LANGUAGE_CODE.Fr}-${getCountryCodeByCountryName(SHIPPING_COUNTRIES.Switzerland)}`,
    `${CENTRA_LANGUAGE_CODE.En}-${getCountryCodeByCountryName(SHIPPING_COUNTRIES.UnitedKingdom)}`,
    `${CENTRA_LANGUAGE_CODE.Fr}-${getCountryCodeByCountryName(SHIPPING_COUNTRIES.Belgium)}`
]

const apacLocales = [
    `${CENTRA_LANGUAGE_CODE.En}-${getCountryCodeByCountryName(SHIPPING_COUNTRIES.Australia)}`,
    `${CENTRA_LANGUAGE_CODE.En}-${getCountryCodeByCountryName(SHIPPING_COUNTRIES.NewZealand)}`
]

const naLocales = [
    `${CENTRA_LANGUAGE_CODE.En}-${getCountryCodeByCountryName(SHIPPING_COUNTRIES.USA)}`,
    `${CENTRA_LANGUAGE_CODE.Fr}-${getCountryCodeByCountryName(SHIPPING_COUNTRIES.Canada)}`,
    `${CENTRA_LANGUAGE_CODE.En}-${getCountryCodeByCountryName(SHIPPING_COUNTRIES.Canada)}`
]

const jpLocales = [
    `${CENTRA_LANGUAGE_CODE.Ja}-${getCountryCodeByCountryName(SHIPPING_COUNTRIES.Japan)}`,
    `${CENTRA_LANGUAGE_CODE.En}-${getCountryCodeByCountryName(SHIPPING_COUNTRIES.Japan)}`
]

const sitePrefixes = [...euLocales, ...apacLocales, ...naLocales, ...jpLocales]

module.exports = {
    SHIPPING_COUNTRY_CODES,
    SHIPPING_COUNTRIES,
    getCountryKeyFromCountryValue,
    getCountryCodeByCountryName,
    CENTRA_LANGUAGE_CODE,
    euLocales,
    apacLocales,
    naLocales,
    jpLocales,
    sitePrefixes
}
